module.exports = __webpack_public_path__ + "static/media/dani_icon_2.ef6d4c69.png";